<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteProducto"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mFeedProductsContentModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        v-if="showLoadingState"
        key="loadingState"
        class="m-the-modal-section"
      >
        <AtomLoadingSecondary/>
      </section>
      <section
        v-else
        key="modalSection"
        class="m-the-modal-section"
      >
        <p>
          {{ $t('mFeedProductsContentModalDelete.messageDelete.element') }}
          <b>{{ element.nombre }}</b>
          {{ $t('mFeedProductsContentModalDelete.messageDelete.options') }}
        </p>
        <small class="font-weight-bold text-color-danger">
            {{ $t('mFeedProductsContentModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mFeedProductsContentModalDelete.buttonCancel')"/>
        <AtomButtonPrimary
          v-if="Object.values(element).length"
          :button-primary="buttonPrimary"
        />
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeFeedProductsContentModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mFeedProductsContentModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      },

      element: {},
      showLoadingState: true
    }
  },

  created () {
    if (this.$modal.element === null) {
      this.readProducto()
    } else {
      this.element = Object.assign({}, this.$modal.element)
      this.showLoadingState = false
    }
  },

  methods: {
    deleteProducto () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('producto', 'deleteProducto', {}, [this.element.id])
          .then(response => {
            this.$modal.updateData('deleteElement')
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedProductsContentModalDelete', 'deleteProducto', 'success')
            if (this.$route.name !== 'products') {
              this.$router.push(`/${this.$t('rPaths.products')}`)
            }
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedProductsContentModalDelete', 'deleteProducto', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    readProducto () {
      this.$services.read('producto', 'readProducto', {}, [this.$route.params.id])
        .then(response => {
          this.element = response.data
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
